var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-map"},[_c('centerTop'),_vm._v(" "),(_vm.mapListData.pointInfoList)?_c('mapTop',{attrs:{"pointInfo":_vm.pointInfo,"mapListData":_vm.mapListData}}):_vm._e(),_vm._v(" "),_c('bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-422ef2c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/patrolScreenMini/components/centerItem/index.vue
// module id = null
// module chunks = 